import { FhirFieldsService, selectedActivityName, selectedActivityType, selectPractitionerAllActive, upsertProgress, upsertUnscheduledProgress, selectedActivity } from '@medlogic/fhir';
import { catchError, map, Observable, tap } from 'rxjs';
import { IPractitioner, IActivity, IProgress, EnCrud, UnsubscribeOnDestroyAdapter, EnActivityType, IField, LogService } from '@medlogic/shared/shared-interfaces';
import { Component, OnInit } from '@angular/core';
import { NavigationPwaService } from '../../service/navigation-pwa.service';
import { MatTableDataSource } from '@angular/material/table';
import { IAppMedlogicState } from '@medlogic/medlogic/medlogic-shared-interfaces';
import { select, Store } from '@ngrx/store';
import { selectSelectedLogin, AppMedlogicPwaCuidadoState } from '@medlogic/medlogic-pwa/medlogic-pwa-cuidado-full';
import { RedisService } from '@medlogic/shared/shared-data-access';

@Component({
  selector: 'ml-patient-care-plan-activity-detail',
  templateUrl: './patient-care-plan-activity-detail.component.html',
  styleUrls: ['./patient-care-plan-activity-detail.component.css']
})
export class PatientCarePlanActivityDetailComponent extends UnsubscribeOnDestroyAdapter implements OnInit {

  activity$: Observable<IActivity> = this.store.select(selectedActivity);
  practitioners$: Observable<MatTableDataSource<IPractitioner>> = this.store.select(selectPractitionerAllActive)
    .pipe(
      map(m => new MatTableDataSource<IPractitioner>(m)),
    );
  selectedPractitioner$ = this.store.pipe(select(selectSelectedLogin));

  crud$: Observable<EnCrud> = this.store.pipe(select(selectedActivity), map(m => m ? EnCrud.update : EnCrud.create));
  activityType$: Observable<EnActivityType> = this.store.pipe(select(selectedActivityType));
  activityName$: Observable<string> = this.store.pipe(select(selectedActivityName));

  fields$ = new Observable<IField[] | null>();

  constructor(
    private log: LogService,
    private nav: NavigationPwaService,
    private store: Store<IAppMedlogicState | AppMedlogicPwaCuidadoState>,
    private fieldsSrv: FhirFieldsService,
    private cache: RedisService
  ) {
    super();
  }

  ngOnInit() {
    this.loadCarePlanFields();
  }

  loadCarePlanFields(): void {
    this.fields$ = this.fieldsSrv.getAll<IField[]>()
      .pipe(
        tap(fields => {
          if (!fields) {
            throw new Error('Erro ao carregar campos do plano de cuidados');
          }
        }),
        catchError((err, obs) => {
          console.error(err);
          return obs;
        })
      )
  }

  onBackClick($event: any): void {
    try {
      this.nav.back();
    } catch (error: any) {
      this.log.Registrar(this.constructor.name, 'onBackClick', error.message);
    }
  }

  onUpdateValues(values: any): void {
    try {

    } catch (error: any) {
      this.log.Registrar(this.constructor.name, 'onUpdateValues', error.message);
    }
  }

  onConfirm(event: { progress: IProgress, activityType: EnActivityType }): void {
    try {
      const { progress, activityType } = event;

      this.subs.sink = this.cache.deleteTenantKeys().subscribe();

      if (activityType === EnActivityType.Scheduled) {
        this.store.dispatch(upsertProgress({ progress }));
      } else {
        this.store.dispatch(upsertUnscheduledProgress({ progress, activityType }))
      }
    } catch (error: any) {
      this.log.Registrar(this.constructor.name, 'onConfirm', error.message);
    }
  }
}
